import { render, staticRenderFns } from "./checkprop.vue?vue&type=template&id=140e3849&"
import script from "./checkprop.vue?vue&type=script&lang=js&"
export * from "./checkprop.vue?vue&type=script&lang=js&"
import style0 from "./checkprop.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports